import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {KM_PREFERENCES_FORM_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {HOME_MATCH_PREFERENCES_SURVEY_CONTENT} from "../../constants/preferences/home_match_preferences_survey_content";
import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../constants/preferences/home_match_preferences_wizard_content";
import {IHomeMatchPreferencesWizardMapActions} from "../../hooks/preferences/use_home_match_preferences_wizard_location_map";
import {HomeMatchPreferencesWizardLocationStep} from "../home_match_preferences_wizard/HomeMatchPreferencesWizardLocationStep";

const {LOCATION_QUESTION} = HOME_MATCH_PREFERENCES_SURVEY_CONTENT;
const {LOCATION_APPLY, LOCATION_CANCEL} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

interface IProps {
    isMapOpen: boolean;
    mapActions: IHomeMatchPreferencesWizardMapActions | null;
    onMapActionsChange: (actions: IHomeMatchPreferencesWizardMapActions | null) => void;
    onMapOpenChange: (isOpen: boolean) => void;
}

export const HomeMatchPreferencesSurveyLocationSection = (props: IProps) => {
    const {isMapOpen, mapActions, onMapActionsChange, onMapOpenChange} = props;
    const {isMobile} = useUserDevice();

    return (
        <div className={sectionStyle}>
            <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                {LOCATION_QUESTION}
            </Text>

            <HomeMatchPreferencesWizardLocationStep
                hideLabel
                isMapOpen={isMapOpen}
                onMapActiveChange={onMapOpenChange}
                onRegisterMapActions={onMapActionsChange}
            />

            {!isMobile && isMapOpen && mapActions && (
                <div className={mapActionsStyle}>
                    <Button
                        dataTestId={KM_PREFERENCES_FORM_TEST_IDS.LOCATION_CANCEL}
                        onClick={mapActions.cancel}
                        size="small"
                        type="button"
                        variant="none_secondary"
                    >
                        {LOCATION_CANCEL}
                    </Button>
                    <Button
                        dataTestId={KM_PREFERENCES_FORM_TEST_IDS.LOCATION_APPLY}
                        onClick={mapActions.apply}
                        size="small"
                        type="button"
                        variant="filled_secondary"
                    >
                        {LOCATION_APPLY}
                    </Button>
                </div>
            )}
        </div>
    );
};

const sectionStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2
});

const mapActionsStyle = css({
    display: "flex",
    gap: 2,
    justifyContent: "flex-end"
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {KM_PREFERENCES_FORM_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {HOME_MATCH_PREFERENCES_SURVEY_CONTENT} from "../../constants/preferences/home_match_preferences_survey_content";
import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../constants/preferences/home_match_preferences_wizard_content";
import {IHomeMatchPreferencesWizardMapActions} from "../../hooks/preferences/use_home_match_preferences_wizard_location_map";
import {HomeMatchPreferencesWizardLocationStep} from "../home_match_preferences_wizard/HomeMatchPreferencesWizardLocationStep";

const {LOCATION_QUESTION} = HOME_MATCH_PREFERENCES_SURVEY_CONTENT;
const {LOCATION_APPLY, LOCATION_CANCEL} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

interface IProps {
    isMapOpen: boolean;
    mapActions: IHomeMatchPreferencesWizardMapActions | null;
    onMapActionsChange: (actions: IHomeMatchPreferencesWizardMapActions | null) => void;
    onMapOpenChange: (isOpen: boolean) => void;
}

export const HomeMatchPreferencesSurveyLocationSection = (props: IProps) => {
    const {isMapOpen, mapActions, onMapActionsChange, onMapOpenChange} = props;
    const {isMobile} = useUserDevice();

    return (
        <div className={sectionStyle}>
            <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                {LOCATION_QUESTION}
            </Text>

            <HomeMatchPreferencesWizardLocationStep
                hideLabel
                isMapOpen={isMapOpen}
                onMapActiveChange={onMapOpenChange}
                onRegisterMapActions={onMapActionsChange}
            />

            {!isMobile && isMapOpen && mapActions && (
                <div className={mapActionsStyle}>
                    <Button
                        dataTestId={KM_PREFERENCES_FORM_TEST_IDS.LOCATION_CANCEL}
                        onClick={mapActions.cancel}
                        size="small"
                        type="button"
                        variant="none_secondary"
                    >
                        {LOCATION_CANCEL}
                    </Button>
                    <Button
                        dataTestId={KM_PREFERENCES_FORM_TEST_IDS.LOCATION_APPLY}
                        onClick={mapActions.apply}
                        size="small"
                        type="button"
                        variant="filled_secondary"
                    >
                        {LOCATION_APPLY}
                    </Button>
                </div>
            )}
        </div>
    );
};

const sectionStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2
});

const mapActionsStyle = css({
    display: "flex",
    gap: 2,
    justifyContent: "flex-end"
});
